import Vue from 'vue';
import { SharedElementDirective, NuxtSharedElementRouteGuard } from 'v-shared-element';

Vue.use(SharedElementDirective, {"duration":"400ms","compositeOnly":true,"includeChildren":true,"restrictToViewport":true,"ignoreTransparency":["img","video"]});

export default NuxtSharedElementRouteGuard;
